import { cn } from '@shared/lib/utils'
import { INFO_BOX_VARIANTS, type InfoBoxVariant } from './form-styles'

interface InfoBoxProps {
  variant?: InfoBoxVariant
  title?: string
  children: React.ReactNode
  className?: string
}

export function InfoBox({
  variant = 'warning',
  title,
  children,
  className,
}: InfoBoxProps) {
  const colors = INFO_BOX_VARIANTS[variant]

  return (
    <div
      className={cn('rounded-2xl border px-5 py-4', className)}
      style={{
        backgroundColor: colors.background,
        borderColor: colors.border,
      }}
    >
      {title && (
        <p className="text-base font-semibold" style={{ color: colors.titleColor }}>
          {title}
        </p>
      )}
      <div
        className={cn('text-sm', title && 'mt-3 space-y-2')}
        style={{ color: colors.textColor }}
      >
        {children}
      </div>
    </div>
  )
}
